import axios from 'axios';

const getAuthorizationUrl = ({
  microsoftPermissionsUsageCategory,
  redirectUri,
  sourceUri,
}) =>
  axios.get('/linked_accounts/get_authorization_url', {
    params: {
      redirect_uri: redirectUri,
      source_uri: sourceUri,
      microsoft_permissions_usage_category:
        microsoftPermissionsUsageCategory || 'base',
    },
  });

export default {
  getAuthorizationUrl,
};
